import React from 'react';
import ck1 from '../../assets/images/ck_1.jpg'
import ck2 from '../../assets/images/cknws.png'

function CoachTestSection() {
  return (
    <>
      <div data-aos="fade-up" className="flex justify-center items-center lg:px-20 p-4">
        <div className="bg-white p-6 md:p-8 rounded-lg shadow-lg flex flex-col md:flex-row w-full">
          {/* Text Section */}
          <div data-aos="fade-up" className="flex-1 md:pr-6 mb-6 md:mb-0">
            <h1  style={{ fontFamily: "Helvetica" }} className="text-center md:text-left text-2xl font-bold text-gray-800 mb-4">Meet The Coach</h1>
            <h2  style={{ fontFamily: "Helvetica" }} className="text-xl font-bold text-gray-700 mb-2">Kshitij Sharma</h2>
            <p  style={{ fontFamily: "Helvetica" }} className="text-sm font-semibold text-gray-600 mb-4">
              Executive Presence Coach, TEDx Speaker & Author
            </p>
            <p className="text-sm text-gray-700 leading-relaxed mb-4">
              Kshitij Sharma, a PCC certified coach with over 3,000 hours of coaching experience across two decades, has guided leaders from various industries in building powerful executive presence. Known for his strong advocacy for women in leadership, Kshitij has coached leaders in global organizations, earning recognition as a top executive coach in 2021 and receiving the Economic Times Achievers Award in 2022. A TEDx speaker and contributing author, his insights on executive presence have been featured in prominent publications. He holds multiple certifications, including from NLP and Positive Intelligence, and has a background in global banking training, previously working with leading firms.
            </p>
            <a
              href="https://coachkshitij.com/about-coach-kshitij/"
              className="text-blue-600 hover:text-blue-800 text-sm font-semibold"
              target="_blank"
              rel="noopener noreferrer"
            >
              Read more...
            </a>
          </div>

          {/* Image Section */}
          <div  data-aos="fade-up" className="flex justify-center items-center w-full md:w-1/3">
            <img
              src={ck1}
              alt="Portrait of Kshitij Sharma, smiling and wearing a grey suit with a blue tie"
              className="rounded-lg shadow-lg lg:w-[300px] lg:h-[300px] object-cover"
            />
          </div>

        </div>
      </div>
      <div   data-aos="fade-up" className="flex flex-col items-center lg:px-20 p-4">
        <div className="flex flex-col lg:flex-row w-full">
          <img
            src={ck2}
            alt="A person in a suit sitting in an office setting, engaged in conversation"
            className="w-full lg:w-[400px] lg:h-[400px] object-cover rounded-lg"
          />
          <div className="flex-1 p-4 flex flex-col justify-center gap-4">
            <h1  style={{ fontFamily: "Helvetica" }} className="text-center font-bold">Our Coaching Philosophy</h1>
            <p   style={{ fontFamily: "Helvetica" }} className="text-center italic font-bold">
              'Awareness of our purpose is the first step in rediscovering greatness within.'
            </p>
            <p className="mt-4 text-center">
              We all have all the answers within us. We just need somebody to support us in discovering them through asking powerful questions. Once we are aware of our “Why”, all the right actions emerge which leads to success and fulfilment. Kshitij’s own “Why” has been to support leaders in this philosophy and be a catalyst in their journey to be more
              <span className="font-bold"> fulfilled and successful in their careers.</span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default CoachTestSection;
